import { useState } from "react";
import axios from "../customAxios.js";
import TrackingResults from "../components/TrackingResults.jsx";

function Tracking() {
  const [searchMode, setSearchMode] = useState(""); 
  const [idReference, setIdReference] = useState("");
  const [phone, setPhone] = useState("");
  const [orderId, setOrderId] = useState("");
  const [loadingError, setLoadingError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [results, setResults] = useState([]);
  const [descriptionText, setDescriptionText] = useState(
    "Selecciona una opción de búsqueda de tu pedido."
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingError("");
    setResults([]);

    if (searchMode === "referencePhone") {
      if (idReference && !phone) {
        setLoadingError("ID referencia debe ir acompañado del celular del cliente");
        return;
      }
      if (!idReference && !phone) {
        setLoadingError("Ingrese # de orden de compra y celular o solo celular");
        return;
      }
    }

    if (searchMode === "orderId" && !orderId) {
      setLoadingError("Ingrese el número de orden");
      return;
    }

    setIsSubmitting(true);

    try {
      let response;

      if (searchMode === "referencePhone") {
        response = await axios.post("/exposed_api/tracking/", {
          idReference,
          phone,
        });
      } else if (searchMode === "orderId") {
        response = await axios.post("/exposed_api/tracking/", {
          orderId,
        });
      }

      console.log("response.data:", response.data);
      setResults(response.data.orders || []);
    } catch (error) {
      setLoadingError("No se encontró información para esa orden.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleItemClick = (item) => {
    console.log("Clicked:", item.idReferencia);
    // navigate(`/tracking/${item.idReferencia}`)
  };

  return (
    <div className="tracking-container">
      <div className="green-header-tracking" align="center">
        <h4 className="title-login fw-medium">Tracking</h4>
      </div>

      <p className="tracking-description">{descriptionText}</p>

      <div className="tracking-mode-buttons">
        <button
          type="button"
          className={`tracking-mode-button ${searchMode === "orderId" ? "active" : ""}`}
          onClick={() => {
            setSearchMode("orderId");
            setLoadingError("");
            setResults([]);
            setDescriptionText("Utiliza el ID Referencia de tu proveedor de despacho");
          }}
        >
          Buscar por ID de orden
        </button>

        <button
          type="button"
          className={`tracking-mode-button ${searchMode === "referencePhone" ? "active" : ""}`}
          onClick={() => {
            setSearchMode("referencePhone");
            setLoadingError("");
            setResults([]);
            setDescriptionText(
              "Utiliza el número de referencia y teléfono exactos que ingresaste al momento de comprar"
            ); // 👈 update text
          }}
        >
          Buscar por referencia y teléfono
        </button>
      </div>

      {/* rest of the component remains the same */}
      {searchMode && (
        <form onSubmit={handleSubmit} className="tracking-form">
          {searchMode === "orderId" && (
            <>
              <label className="tracking-label">Número de orden</label>
              <input
                type="text"
                className="tracking-input"
                placeholder="Ej: 78910"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
              />
            </>
          )}

          {searchMode === "referencePhone" && (
            <>
              <label className="tracking-label">Orden de compra</label>
              <input
                type="text"
                className="tracking-input"
                placeholder="Ej: 123456"
                value={idReference}
                onChange={(e) => setIdReference(e.target.value)}
              />

              <label className="tracking-label">Teléfono</label>
              <input
                type="tel"
                className="tracking-input"
                placeholder="Ej: +56 9 1234 5678"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </>
          )}

          <div className="tracking-button-container">
            <button
              type="submit"
              className="tracking-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Buscando..." : "Buscar"}
            </button>
          </div>

          {loadingError && <p className="tracking-error">{loadingError}</p>}
        </form>
      )}

      {results.length > 0 && (
        <TrackingResults results={results} onItemClick={handleItemClick} />
      )}
    </div>
  );
}

export default Tracking;
